import { i18n } from "i18n/index";
import * as Yup from "yup";

export const REGISTER_INITIAL_VALUE = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  code: "",
  checkbox: "",
};
export const LOGIN_INITIAL_VALUE = {
  email: "",
  password: "",
};
export const CONTACT_US_INITIAL_VALUE = {
  name: "",
  contactNumber: "",
  message: "",
};

export const REGISTER_VALIDATION_SHEMA = Yup.object({
  firstName: Yup.string()
    .max(20, i18n.t("auth.maxName"))
    .required(i18n.t("Name must not be empty")),
  lastName: Yup.string().required(i18n.t("Last Name must not be empty")),
  email: Yup.string()
    .email(i18n.t("Email format is incorrect"))
    .required(i18n.t("Email must not be empty")),
  password: Yup.string().required(i18n.t("Password must not be empty")),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], i18n.t("The password must be the same"))
    .required(i18n.t("Password must not be empty")),
  code: Yup.string().required(i18n.t("Code must not be empty")),
  checkbox: Yup.string().required(i18n.t("select")),
});

export const LOGIN_VALIDATION_SHEMA = Yup.object({
  email: Yup.string()
    .email(i18n.t("Email format is incorrect"))
    .required(i18n.t("Email must not be empty")),
  password: Yup.string().required(i18n.t("Password must not be empty")),
});

export const CONTACT_US_VALIDATION_SHEMA = Yup.object({
  name: Yup.string().required(i18n.t("Name must not be empty")),
  message: Yup.string().required(i18n.t("Message text cannot be empty")),
  contactNumber: Yup.string()
    .matches(/^(\+98|0|98)?9\d{9}$/, i18n.t("Contact number is not valid"))
    .required(i18n.t("Contact number could not be blank ")),
});
